import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export function SuggestPhone({ b }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [phone, setPhone] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  if (sent) {
    return <p className="text-center text-xs font-semibold text-[#166534]" data-testid="suggest-phone-sent">Merci ! Le numéro sera affiché après vérification.</p>;
  }
  if (!user) {
    return (
      <Link to={`/connexion?next=${encodeURIComponent(`/entreprise/${b.id}`)}`} className="block text-center text-xs font-semibold text-slate-600 hover:text-[#1E40AF] hover:underline" data-testid="suggest-phone-login-link">
        Vous connaissez le numéro ? Connectez-vous pour le proposer
      </Link>
    );
  }
  if (!open) {
    return (
      <button onClick={() => setOpen(true)} className="block w-full text-center text-xs font-semibold text-slate-600 hover:text-[#1E40AF] hover:underline" data-testid="suggest-phone-open">
        Vous connaissez le numéro ? Proposez-le
      </button>
    );
  }
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post(`/businesses/${b.id}/phone-suggestions`, { phone });
      setSent(true);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit} className="flex gap-2" data-testid="suggest-phone-form">
      <Input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="04 00 00 00 00" required className="h-9 bg-white text-sm" data-testid="suggest-phone-input" />
      <Button type="submit" size="sm" disabled={busy} className="h-9 bg-[#1E40AF] hover:bg-[#1D4ED8] hover:text-white" data-testid="suggest-phone-submit">Proposer</Button>
    </form>
  );
}
